import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'src/app/App';
import { initStore } from 'src/app/store';

// Global init
const store = initStore(__USE_MOCK_DATA__ ? {} : undefined);

// Load React
const rootDOMElement = document.getElementById('app') as HTMLElement;
const render = (AppComponent = App) =>
  ReactDOM.render(
    <Provider store={store}>
      <AppComponent />
    </Provider>,
    rootDOMElement,
  );

render(App);

if ((module as any).hot) {
  (module as any).hot.accept(['./app/App'], () => {
    console.log('Hot Reloading..');
    ReactDOM.unmountComponentAtNode(rootDOMElement);
    const NextApp = require('./app/App').default;
    render(NextApp);
  });
}

console.log(
  `App started. __ENVIRONMENT__ is ${__ENVIRONMENT__}, __VERSION__ is ${__VERSION__}, NODE_ENV is ${
    process.env.NODE_ENV
  }, MOCK MODE IS ${__USE_MOCK_DATA__}`,
);
